module.exports = __webpack_public_path__ + "img/camera_8.4cab9e6e.png";